import { Table } from 'react-bootstrap';
import type { TrackingMoreDetail } from '@/models/FedExTrackingDetail';

interface TrackingMoreTimelineProps {
  tracking: TrackingMoreDetail;
}

const formatKoreaTime = (timestamp: string): string =>
  new Date(timestamp).toLocaleString('en-GB', { timeZone: 'Asia/Seoul', hour12: false });

/** Operational history is deliberately not filtered through customer milestone enums. */
export function TrackingMoreTimeline({ tracking }: TrackingMoreTimelineProps) {
  const checkpoints = [...tracking.checkpoints]
    .filter((checkpoint) => Number.isFinite(Date.parse(checkpoint.checkpointDate)))
    .sort((left, right) => Date.parse(right.checkpointDate) - Date.parse(left.checkpointDate));

  return (
    <section className="mt-4" aria-label="TrackingMore details">
      <div className="text-sm font-medium mb-2">TRACKING HISTORY · TrackingMore ({checkpoints.length})</div>
      <Table responsive aria-label="TrackingMore history">
        <thead>
          <tr>
            <th>Time (KST)</th>
            <th>Description</th>
            <th>Location</th>
            <th>TrackingMore Code</th>
          </tr>
        </thead>
        <tbody>
          {checkpoints.map((checkpoint, index) => (
            <tr key={`${checkpoint.checkpointDate}-${checkpoint.deliverySubstatus}-${index}`}>
              <td className="text-sm whitespace-nowrap">{formatKoreaTime(checkpoint.checkpointDate)}</td>
              <td className="text-sm">{checkpoint.trackingDetail || '-'}</td>
              <td className="text-sm">{checkpoint.location || '-'}</td>
              <td className="text-sm">{checkpoint.deliverySubstatus || checkpoint.deliveryStatus || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}
